import axios from "axios";
import { newApiBaseUrl } from "../../axiosInstance";

export const getFiltersWithItems = (kind) => {
  if (!kind || String(kind).trim() === "" || String(kind) === "undefined") {
    return Promise.reject(new Error("getFiltersWithItems: missing kind"));
  }
  return axios.get(`${newApiBaseUrl}/dict/${kind}`, {
    headers: {
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
      "Content-Type": "application/json",
    },
  });
};

export const editItem = (kind, Id, item) => {
  return axios.patch(`${newApiBaseUrl}/dict/${kind}/${Id}`, item, {
    headers: {
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
      "Content-Type": "application/json",
    },
  });
};
export const editItemPosition = (kind, id, position) => {
  kind = String(kind || "").replace(/^hamazon-/, "");

  return axios.patch(
    `${newApiBaseUrl}/dict/${kind}/position/${id}`,
    { position },
    {
      headers: {
        Authorization: `Bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
        "Content-Type": "application/json",
      },
    },
  );
};

export const deleteItemInFilter = (data, kind) => {
  const id = data.id;

  return axios.delete(`${newApiBaseUrl}/dict/${kind}/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
      "Content-Type": "application/json",
    },
  });
};

export const createItemInFilter = (kind, item) => {
  const kindy = kind.replace("hamazon-", "");
  return axios.post(`${newApiBaseUrl}/dict/${kindy}`, item, {
    headers: {
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
      "Content-Type": "application/json",
    },
  });
};

export const getPresignedUrl = (file, folder, productId) => {
  return axios.post(
    `${newApiBaseUrl}/create-s3-presigned`,
    {
      fileName: file.name,
      fileType: file.type,
      size: file.size,
      folder: folder,
      productId: productId ?? file.name,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
        "Content-Type": "application/json",
      },
    },
  );
};

// not in use now
/*
export const getFilters = (kind) => {
  return (dispatch) => {
    if (!kind || String(kind).trim() === "" || String(kind) === "undefined") {
      if (process.env.NODE_ENV !== "production") {
        console.warn("getFilters skipped: missing kind", { kind });
      }
      return;
    }
    axios
      .get(`${newApiBaseUrl}/dict/${kind}`, {
        headers: {
          Authorization: `Bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
          "Content-Type": "application/json",
        },
      })
      .then((x) => {
        console.log(x.data, "x");

        dispatch({
          type: actionType.SET_FILTER,
          payload: {
            kind,
            items: x.data,
          },
        });
      })
      .catch((err) => {
        console.error("שגיאה בטעינת פילטרים:", err);
      });
  };
};
*/
